import React, { useContext } from 'react';
import styles from './index.module.scss';
import elec_icon from '../../../../imgs/elec_icon.png';
import pv_img from '../../../../imgs/pv_img.png';
import { Progress, ProgressProps } from 'antd';
import { ShareDataWrapperContext } from '../..';
import { isNil } from 'lodash-es';
import { formatThousandUnitDefaultTwo, keepTwoOrLine, keepTwoOrNull, keepTwoWithNumberOrLine } from '@/utils/utils';
import { OverviewDateType } from '@/pages/EnergyStatisticalReport/const';

const twoColors: ProgressProps['strokeColor'] = {
  '0%': '#92ED79',
  '100%': '#59D744',
};

interface ElecCardProps {
  showPhotovoltaic: boolean;
}

const ElecCard = ({ showPhotovoltaic }: ElecCardProps) => {
  const { overviewData, timeResolution } = useContext(ShareDataWrapperContext);

  return (
    <div className={styles.elec_wrapper}>
      <div className={styles.top}>
        <img className={styles.icon} src={elec_icon} alt="" />
        <div className={styles.title}>用电量统计</div>
      </div>
      <div className={`${styles.bottom} ${!showPhotovoltaic ? styles.bottom_without_photovoltaic : ''}`}>
        <div className={styles.elec_rate_wrapper} style={{ paddingBottom: 0 }}>
          <div className={styles.elec_rate_progress}>
            <Progress
              type="circle"
              size={80}
              percent={
                !isNil(overviewData?.electricityInfo?.planRatio)
                  ? keepTwoOrNull(overviewData?.electricityInfo?.planRatio)!
                  : undefined
              }
              strokeColor={twoColors}
              trailColor="#28323F"
              format={() => {
                return (
                  <span style={{ fontSize: 14 }}>
                    {keepTwoWithNumberOrLine(overviewData?.electricityInfo?.planRatio)}%
                  </span>
                );
              }}
            />
          </div>
          <div className={styles.elec_rate_text}>
            <div className={styles.item}>
              <div className={styles.label}>电能实际用量(kWh)</div>
              <div className={styles.act_value}>
                {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.total)}
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.label}>
                {timeResolution === OverviewDateType.MONTH ? '本月' : '本年'}计划用量(kWh)
              </div>
              <div className={styles.plan_value}>
                {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.plan)}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.time_slot}>
          <div className={styles.item}>
            <div className={styles.item_top}>
              <div className={styles.label} style={{ color: '#FF6D2C' }}>
                尖时段
              </div>
              <div className={styles.value}>{keepTwoOrLine(overviewData?.electricityInfo?.summit?.ratio)}%</div>
            </div>
            <div className={styles.item_bottom}>
              {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.summit?.value)}kWh
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.item_top}>
              <div className={styles.label} style={{ color: '#CE90D1' }}>
                峰时段
              </div>
              <div className={styles.value}>{keepTwoOrLine(overviewData?.electricityInfo?.peak?.ratio)}%</div>
            </div>
            <div className={styles.item_bottom}>
              {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.peak?.value)}kWh
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.item_top}>
              <div className={styles.label} style={{ color: '#0DB6D9' }}>
                平时段
              </div>
              <div className={styles.value}>{keepTwoOrLine(overviewData?.electricityInfo?.plain?.ratio)}%</div>
            </div>
            <div className={styles.item_bottom}>
              {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.plain?.value)}kWh
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.item_top}>
              <div className={styles.label} style={{ color: '#63BC7F' }}>
                谷时段
              </div>
              <div className={styles.value}>{keepTwoOrLine(overviewData?.electricityInfo?.valley?.ratio)}%</div>
            </div>
            <div className={styles.item_bottom}>
              {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.valley?.value)}kWh
            </div>
          </div>
        </div>
        {showPhotovoltaic && (
          <>
            <div className={styles.dash}></div>
            <div className={styles.elec_rate_wrapper} style={{ padding: '0px 16px' }}>
              <div className={styles.elec_rate_progress}>
                <img className={styles.pv_img} src={pv_img} alt="" />
              </div>
              <div className={styles.elec_rate_text}>
                <div className={styles.item}>
                  <div className={styles.label}>光伏发电总量(kWh)</div>
                  <div className={styles.act_value}>
                    {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.pvTotal)}
                  </div>
                </div>
                <div className={styles.green_rate}>
                  <div className={styles.label}>绿电占比:</div>
                  <div className={styles.value}>{keepTwoOrLine(overviewData?.electricityInfo?.greenRatio)}%</div>
                </div>
              </div>
            </div>
            <div className={styles.time_slot}>
              <div className={styles.item}>
                <div className={styles.item_top}>
                  <div className={styles.label} style={{ color: '#FF6D2C' }}>
                    尖时段
                  </div>
                  <div className={styles.value}>{keepTwoOrLine(overviewData?.electricityInfo?.pvSummit?.ratio)}%</div>
                </div>
                <div className={styles.item_bottom}>
                  {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.pvSummit?.value)}kWh
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.item_top}>
                  <div className={styles.label} style={{ color: '#CE90D1' }}>
                    峰时段
                  </div>
                  <div className={styles.value}>{keepTwoOrLine(overviewData?.electricityInfo?.pvPeak?.ratio)}%</div>
                </div>
                <div className={styles.item_bottom}>
                  {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.pvPeak?.value)}kWh
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.item_top}>
                  <div className={styles.label} style={{ color: '#0DB6D9' }}>
                    平时段
                  </div>
                  <div className={styles.value}>{keepTwoOrLine(overviewData?.electricityInfo?.pvPlain?.ratio)}%</div>
                </div>
                <div className={styles.item_bottom}>
                  {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.pvPlain?.value)}kWh
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.item_top}>
                  <div className={styles.label} style={{ color: '#63BC7F' }}>
                    谷时段
                  </div>
                  <div className={styles.value}>{keepTwoOrLine(overviewData?.electricityInfo?.pvValley?.ratio)}%</div>
                </div>
                <div className={styles.item_bottom}>
                  {formatThousandUnitDefaultTwo(overviewData?.electricityInfo?.pvValley?.value)}kWh
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ElecCard;
